import * as actionTypes from '@store/actions/actionTypes'
import { phoenixMountainPreserve } from '@util/constants'
import isEqual from 'lodash.isequal'

const initialState = {
  propertyView: 'photo-centric',
  propertyMediaView: 'media',
  dataView: 'combined',
  mainMenuOpen: false,
  agentDrawerOpen: false,
  lists: [],
  pointsOfInterest: [],
  pointsOfInterestLoading: true,
  poiProximityLngLat: phoenixMountainPreserve,
  stats: {},
  userSavedProperties: [],
  userNetworkFavorites: [],
  shareProperty: {
    query: '',
    searchId: null,
    suggestions: [],
    recipients: []
  },
  shareResource: {
    query: '',
    searchId: null,
    suggestions: [],
    recipients: []
  },
  savedSearch: {},
  userCreatedInMongo: false,
  userDataLoaded: false,
  armlsLogonType: '',
  armlsLogonTypePending: true,
  connectedToNetwork: false,
  connectedToAgent: false,
  agents: [],
  preferences: {
    loading: false,
    showLargeTaxDetailMap: false
  },
  viewedAgentSelector: false,
  showFirstLoginHelp: false,
  justLoggedIn: false,
  featurePermissions: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_PREFERENCE:
      return {
        ...state,
        preferences: { ...state.preferences, ...action.obj }
      }
    case actionTypes.SET_USER_CONNECTED_TO_NETWORK:
      return {
        ...state,
        connectedToNetwork: true
      }
    case actionTypes.SET_USER_CONNECTED_TO_AGENT:
      return {
        ...state,
        connectedToAgent: true
      }
    case actionTypes.SET_USER_CREATED_IN_MONGO:
      return {
        ...state,
        userCreatedInMongo: true
      }
    case actionTypes.SET_PROPERTY_SHARE_LOOKUP:
      return {
        ...state,
        shareProperty: { ...state.shareProperty, query: action.query }
      }
    case actionTypes.SET_PROPERTY_SHARE_SUGGESTIONS:
      return {
        ...state,
        shareProperty: {
          ...state.shareProperty,
          suggestions: action.suggestions
        }
      }
    case actionTypes.SET_PROPERTY_SHARE_LOOKUP_SEARCHID:
      return {
        ...state,
        shareProperty: { ...state.shareProperty, searchId: action.id }
      }
    case actionTypes.ADD_PROPERTY_SHARE_RECIPIENT:
      return {
        ...state,
        shareProperty: {
          ...state.shareProperty,
          recipients: [...state.shareProperty.recipients, action.recipient]
        }
      }
    case actionTypes.SET_PROPERTY_SHARE_RECIPIENTS:
      return {
        ...state,
        shareProperty: { ...state.shareProperty, recipients: action.recipients }
      }
    case actionTypes.SET_RESOURCE_SHARE_LOOKUP:
      return {
        ...state,
        shareResource: { ...state.shareResource, query: action.query }
      }
    case actionTypes.SET_RESOURCE_SHARE_SUGGESTIONS:
      return {
        ...state,
        shareResource: {
          ...state.shareResource,
          suggestions: action.suggestions
        }
      }
    case actionTypes.SET_RESOURCE_SHARE_LOOKUP_SEARCHID:
      return {
        ...state,
        shareResource: { ...state.shareResource, searchId: action.id }
      }
    case actionTypes.ADD_RESOURCE_SHARE_RECIPIENT:
      return {
        ...state,
        shareResource: {
          ...state.shareResource,
          recipients: [...state.shareResource.recipients, action.recipient]
        }
      }
    case actionTypes.SET_RESOURCE_SHARE_RECIPIENTS:
      return {
        ...state,
        shareResource: { ...state.shareResource, recipients: action.recipients }
      }
    case actionTypes.SET_POI:
      return {
        ...state,
        pointsOfInterest: [...state.pointsOfInterest, action.poi]
      }
    case actionTypes.SET_POIS:
      return {
        ...state,
        pointsOfInterest: action.data
      }
    case actionTypes.SET_POIS_LOADING:
      return {
        ...state,
        pointsOfInterestLoading: action.bool
      }
    case actionTypes.SET_POI_PROXIMITY:
      return {
        ...state,
        poiProximityLngLat: action.lnglat
      }
    case actionTypes.SET_PROPERTY_VIEW:
      return {
        ...state,
        propertyView: action.view
      }
    case actionTypes.TOGGLE_DATA_VIEW:
      return {
        ...state,
        dataView: action.view
      }
    case actionTypes.TOGGLE_MAIN_MENU:
      return {
        ...state,
        agentDrawerOpen: false,
        mainMenuOpen: action.bool
      }
    case actionTypes.TOGGLE_AGENT_DRAWER:
      return {
        ...state,
        mainMenuOpen: false,
        agentDrawerOpen: action.bool
      }
    case actionTypes.SET_USER_SAVED_PROPERTIES:
      return {
        ...state,
        userSavedProperties: action.response
      }
    case actionTypes.SET_FAV_PROPERTY:
      return {
        ...state,
        userSavedProperties: [
          ...state.userSavedProperties.filter(
            p => !isEqual(p.docId, action.docId)
          ),
          { docId: action.docId, value: 1 }
        ]
      }
    case actionTypes.SET_HIDDEN_PROPERTY:
      return {
        ...state,
        userSavedProperties: [
          ...state.userSavedProperties.filter(
            p => !isEqual(p.docId, action.docId)
          ),
          { docId: action.docId, value: -1 }
        ]
      }
    case actionTypes.SET_NEUTRAL_PROPERTY:
      return {
        ...state,
        userSavedProperties: state.userSavedProperties.filter(
          p => !isEqual(p.docId, action.docId)
        )
      }
    case actionTypes.SET_USER_NETWORK_FAVORITES:
      return {
        ...state,
        userNetworkFavorites: action.response
      }
    case actionTypes.SET_PROPERTY_MEDIA_VIEW:
      return {
        ...state,
        propertyMediaView: action.view
      }
    case actionTypes.SET_USER_SAVED_LISTS:
      return {
        ...state,
        lists: action.data
      }
    case actionTypes.SET_SELECTED_LIST:
      return {
        ...state,
        selectedList: action.obj
      }
    case actionTypes.REMOVE_ITEM_FROM_LIST:
      return {
        ...state,
        lists: state.lists.map(l => {
          if (l.listId === action.listId) {
            return {
              ...l,
              data: l.data.filter(d => !isEqual(d, action.docId))
            }
          }
          return l
        })
      }
    case actionTypes.REMOVE_ITEM_FROM_SELECTED_LIST:
      return {
        ...state,
        selectedList: {
          ...state.selectedList,
          data: state.selectedList.data.filter(d => !isEqual(d, action.docId))
        }
      }
    case actionTypes.ADD_ITEM_TO_SELECTED_LIST:
      return {
        ...state,
        selectedList: {
          ...state.selectedList,
          data: [...state.selectedList.data, action.docId]
        }
      }
    case actionTypes.SET_USER_STATS:
      return {
        ...state,
        stats: action.obj
      }
    case actionTypes.SET_USER_DATA_LOADED:
      return {
        ...state,
        userDataLoaded: action.bool
      }
    case actionTypes.SET_SAVED_SEARCH:
      return {
        ...state,
        savedSearch: action.obj
      }
    case actionTypes.SET_SAVED_SEARCH_LOADED:
      return {
        ...state,
        savedSearchLoaded: action.bool
      }
    case actionTypes.SET_SAVED_SEARCH_NAME:
      return {
        ...state,
        savedSearch: {
          ...state.savedSearch,
          name: action.name
        }
      }
    case actionTypes.SET_VIEWED_AGENT_SELECTOR:
      return {
        ...state,
        viewedAgentSelector: action.bool
      }
    case actionTypes.SET_ARMLS_LOGON_TYPE:
      return {
        ...state,
        armlsLogonType: action.obj.type,
        armlsLogonTypePending: action.obj.pending
      }
    case actionTypes.SET_USER_AGENTS:
      return {
        ...state,
        agents: action.agents
      }
    case actionTypes.SET_USER_PROFILE_IMAGE:
      return {
        ...state,
        profileImage: action.data
      }
    case actionTypes.CLEAR_USER_PROFILE_IMAGE:
      return {
        ...state,
        profileImage: null
      }
    case actionTypes.SET_SHOW_FIRST_LOGIN_HELP:
      return {
        ...state,
        showFirstLoginHelp: action.bool
      }
    case actionTypes.SET_JUST_LOGGED_IN:
      return {
        ...state,
        justLoggedIn: action.bool
      }
    case actionTypes.SET_USER_FLEX_DATA:
      return {
        ...state,
        flexData: action.obj
      }
    case actionTypes.SET_USER_PERMISSIONS:
      return {
        ...state,
        permissions: action.obj
      }
    case actionTypes.SET_FEATURE_PERMISSIONS:
      return {
        ...state,
        featurePermissions: action.obj
      }
    case actionTypes.SET_REGISTERED_GUEST_DEMOGRAPHICS:
      return {
        ...state,
        registeredGuestData: action.obj
      }
    default:
      return state
  }
}

export default reducer
